<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1 class="text-center">Asian Breakout</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-3">
            <mdb-form-control>
                <input mdbInput [mdbDatepicker]="datepicker" type="text" class="form-control" id="exampleDatepicker"
                    [(ngModel)]="data_selezionata" />
                <label mdbLabel for="exampleDatepicker" class="form-label">Select a date</label>
                <mdb-datepicker-toggle [mdbDatepicker]="datepicker"></mdb-datepicker-toggle>
                <mdb-datepicker [confirmDateOnSelect]="true" [options]="translationOptions" [format]="'dd-mm-yyyy'" #datepicker></mdb-datepicker>
                <!-- (dateChanged)="onDateChange($event)"-->
            </mdb-form-control>
        </div>
        <div class="col-3">
            <button class="btn btn-primary" (click)="getOperazioni()">Get Operazioni</button>
        </div>
    </div>
    <div class="row mt-5">
        <table class="table">
            <thead>
                <tr>
                    <th>Symbol</th>
                    <th>Max</th>
                    <th>Min</th>
                    <th>In corso</th>
                    <th>CrossTrend</th>
                    <th>Verso</th>
                    <th>Ora</th>
                    <th>Prezzo</th>
                    <th>Tipo</th>
                    <th>Ora</th>
                    <th>Prezzo finale</th>
                    <th>Profit</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="bSpinner">
                    <td class="text-center" colspan="12">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </td>
                </tr>
                <tr *ngFor="let trade of listaOperazioni">
                    <td>{{trade.mkt}}</td>
                    <td>{{trade.buyprice}}</td>
                    <td>{{trade.sellprice}}</td>
                    <td>{{trade.incorso}}</td>
                    <td>{{trade.ct | number: '1.2-2'}}</td>
                    <td>{{trade.verso}}</td>
                    <td>{{trade.oraopen | date : 'HH:ss'}}</td>
                    <td>{{trade.priceopen}}</td>
                    <td>{{trade.tipo}}</td>
                    <td>{{trade.oraclose | date: 'HH:ss'}}</td>
                    <td>{{trade.closeprice}}</td>
                    <td>{{trade.profit | number: '1.4-4'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>